/**
 * The main api service
 */
import http from '@util/http';
import { core } from '@api/req';

export async function queryFunctionListTree(params) {
  return http.get(core.GET_FUNCTION_LIST_TREE, params);
}

export async function queryFunctionListTreeEnable(params) {
  return http.get(core.GET_FUNCTION_LIST_TREE_ENABLE, params);
}

export async function queryMyFunctionListTree(params) {
  return http.get(core.GET_MY_FUNCTION_LIST_TREE, params);
}

export async function queryFunctionInfo(params) {
  return http.get(core.GET_FUNCTION_INFO, params);
}

export async function queryDeleteFunction(params) {
  return http.get(core.DELETE_FUNCTION, params);
}

export async function querySaveFunction(params) {
  return http.post(core.SAVE_FUNCTION, params);
}



// WEBPACK FOOTER //
// ./src/api/core/function.js